<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb :page-title="title" :icon="'user-check'" />
      </div>
    </div>

    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 4">
          <a href="" @click.prevent="previous">List</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="active === 2"
          >Applied Certificate Detail</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>

    <el-form v-if="active === 1">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- <h5 class="mb-3">{{ $t('tab_filter') }} </h5> -->
          <div class="card card-with-shadow border-0 bg-transparent">
            <!-- <div class="card-header d-flex align-items-center p-primary primary-card-color">
                  <h5 class="card-title d-inline-block mb-0">{{ $t('profile_view')}}</h5>
                  <app-search @input="getSearchValue"/>
              </div> -->
            <div
              class="
                p-primary
                align-items-center
                primary-card-color
                border-bottom
              "
            >
              <ul
                class="
                  nav
                  tab-filter-menu
                  d-inline-flex
                  justify-content-flex-end
                "
              >
                <li
                  class="nav-item"
                  v-for="(item, index) in userFilterOptions"
                  :key="index"
                >
                  <a
                    href="#"
                    class="nav-link font-size-default py-0"
                    :class="[
                      filteredData.status == item.id
                        ? 'active'
                        : index === 0 && filteredData.status === ''
                        ? 'active'
                        : '',
                    ]"
                    @click.prevent="getFilterValue(item.id)"
                  >
                    {{ item.value }}
                  </a>
                </li>
              </ul>
              <div class="float-right">
                <app-search @input="getSearchValue" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
        :filtered-data="filteredData"
      />
    </el-form>

    <el-form v-if="active === 2">
      <request-company-detail
        :companyId="companyId"
        :certificateId="certificateId"
        :remove="classRemove"
      ></request-company-detail>
    </el-form>

    <buyer-certificate-request-view-modal
      v-if="isRequestModalActive"
      :companyId="company_id"
      :certificateId="certificate_id"
      @close-modal="closeRequestModal"
    />
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";
import { axiosGet } from "../../../../../../Helpers/AxiosHelper";

export default {
  // extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  data() {
    return {
      title: "",
      classRemove: true,
      active: 1,
      companyId: 0,
      certificateId: 0,
      isRequestModalActive: false,
      isAddEditModalActive: false,
      isEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      titleinvoice: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.BUYER_CERTIFICATE_REQUESTS,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("company"),
            type: "custom-html",
            key: "company",
            isVisible: true,
            modifier: (value) => {
              return `<span>${this.$t(value.company_name)}</span>`;
            },
          },
          {
            title: this.$t("certificate"),
            type: "custom-html",
            key: "certificate",
            isVisible: true,
            modifier: (value) => {
              return `<span>${this.$t(value.title)}</span>`;
            },
          },
          {
            title: this.$t("applied_date"),
            type: "custom-html",
            key: "date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "accepted") ClassName = `success`;
              else if (value === "rejected") ClassName = `warning`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          // {
          //   title: this.$t("action"),
          //   type: "custom-html",
          //   key: "company",
          //   modifier: (value) => {
          //     return (
          //       `<a href="request/company/detail/` +
          //       value.id +
          //       `" class='btn btn-primary'>${this.$t("view")}</a>
          //                               <a href="buyer-request/status" class='btn btn-success'>${this.$t(
          //                                 "accept"
          //                               )}</a>
          //                               <a href="#" class='btn btn-danger'>${this.$t(
          //                                 "reject"
          //                               )}</a>`
          //     );
          //   },
          // },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          // {
          //   title: this.$t("accept"),
          //   icon: "thumbs-up",
          //   type: "none",
          // },
          {
            title: this.$t("reject"),
            icon: "thumbs-down",
            type: "none",
          },
          // {
          //     title: this.$t('download'),
          //     icon: 'download',
          //     type: 'none',
          // }
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All" },
        { id: "accepted", value: "In Progress" },
        { id: "pending", value: "Pending" },
        { id: "rejected", value: "Rejected" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    previous() {
      this.active = 1;
    },
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;
      
      this.$hub.$emit("reload-" + this.tableId);
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        // this.$emit("id", rowData.id);
        this.companyId = rowData.company.id;
        this.certificateId = rowData.compliance_certificate_id;
        this.active = 2;
        // this.isRequestModalActive = true;
      } else if (actionObj.title == this.$t("reject")) {
          if (rowData.status == 'rejected' || rowData.status == 'accepted') {
            this.$toastr.s('Action is not allowed');
          }
          else {
            this.certificateReject(rowData.id);
          }
      } else if (actionObj.title == this.$t("accept")) {
          if (rowData.status == 'accepted' || rowData.status == 'rejected') {
            this.$toastr.s('Action is not allowed');
          }
          else {
              
          }
        
      }
    },

    certificateReject(id) {
      axiosGet(actions.CERTIFICATE_REJECT + "/" + id)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.$hub.$emit("reload-" + this.tableId);
        })
        .catch((error) => {
          
        });
    },
    closeRequestModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isRequestModalActive = false;
    },
  },
  mounted() {
    let role;
    var url = window.location.pathname;
    var id = url.substring(url.lastIndexOf("/") + 1);
    if (id == "buyer-request") {
      role = "buyer";
      this.title = "New Buyer Request";
    } else {
      role = "supplier";
      this.title = "New Supplier Request";
    }
    this.options.url = actions.BUYER_CERTIFICATE_REQUESTS + "?role=" + role;
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
